<div class="back-btn-wrapper">
  <span class="back-btn" (click)="goBack()"
    ><img class="back-icon" src="assets/20x20/arrow-back.svg" /> Back</span
  >
</div>
